module.exports = __webpack_public_path__ + "media/images/ALLCARE_ACADEMY_Banner_4-9de45e17cc92807fe6b6280c54de5496.jpg";